import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { PdfTemplateContext } from '../../../../context/PdfTemplateContext';
import { useToast } from '../../../../providers/ToastProvider';
import { useRequest } from '../../../../requests/common/requestHook';
import { PdfTemplateRequest } from '../../../../requests/pdf.request';
import { PdfTemplate, PdfTemplateInput } from '../../../../types/pdf_template';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { translate } from '../../../../types/translation/Translator';
import { Routing } from '../../../../util/routes.util';
import { CancelButton, DeleteButton } from '../../../components/Button';
import { AlertModal } from '../../../components/Modal';
import { ToastType } from '../../../components/Toast';

interface PdfTemplateConfirmDeleteModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  pdfTemplate: PdfTemplate;
}

export default function PdfTemplateConfirmDeleteModal({
  open,
  setOpen,
  pdfTemplate,
}: PdfTemplateConfirmDeleteModalProps) {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const { pdfTemplates, setPdfTemplates } = useContext(PdfTemplateContext);

  const [remove, { loading }] = useRequest(PdfTemplateRequest.remove);

  const handleDelete = async () => {
    const result = await remove({ data: [new PdfTemplateInput(pdfTemplate).forDelete()] });
    if (!result) return;

    showToast({
      type: ToastType.success,
      title: translate({ key: TranslationKey.pdfTemplateDeletedSuccessfullyToastTitle }),
    });

    pdfTemplates.delete(pdfTemplate.id);
    setPdfTemplates(new Map(pdfTemplates));
    setOpen(false);
    navigate(Routing.dashboard());
  };

  return (
    <AlertModal open={open} setOpen={setOpen} title={'Are you sure you want to delete this template?'}>
      <p className='text-subtitle'>This action cannot be undone!</p>
      <div className='flex justify-end gap-2'>
        <CancelButton onClick={() => setOpen(false)} disabled={loading} />
        <DeleteButton onClick={handleDelete} loading={loading} />
      </div>
    </AlertModal>
  );
}
